export class Discount {
  discount_pkid: number;
  discount_name: string;
  discount_primary_type: string;
  discount_minimum_requirement: string;
  discount_value_type: string;
  discount_minimum_requirement_quantity: number;
  discount_max_uses_per_order: number;
  discount_value: number;
  discount_minimum_requirement_amount: number;
  applications: {};
  discount_get_iscvsd_pkid: string;
  discount_buy_quantity: number;
  isAvailable: boolean = true;
  selected: boolean = false;
  limitReached: boolean = false;

  discount_buy_iscvsd_pkid: string;
  discount_get_quantity: number;
  discount_iscvsd_pkid: string;
  discount_caption: string;

  // This model is shared by both rewards and discounts.
  // Use 'isDiscount' to distinguish whether this instance is a discount (true) or a reward (false).
  rewardPkid = 0;
  point = 0;
  max_value: number;
  constructor(data: Partial<Discount>) {
    Object.assign(this, data);
    this.applications = {};
  }

  // totalApplications() {
  //   return Object.values(this.applications).reduce((total: number, count: number) => total + count, 0) as number
  // }
  // get isAvailable() {
  //   return this.totalApplications < this.discount_max_uses_per_order;
  // }
}